export const state = {
    agency_certificates_for_vetting: [],
    agency_info: [],
    authentication_stats: {},
    certificates_history: [],

    authentication_modal_data: null,
    selected_certificate_for_authentication: [],
};

export const actions = {
    //eslint-disable-next-line
    setCertificatesForVetting({ commit, state }) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/validations/getcertificatesforvetting")
                //eslint-disable-next-line
                .then((response) => {
                    commit("setCertificatesForVetting", response.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    sendCertificatesForVetting({ commit, state }, requestObject) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/validations/sendcertificatesforvetting", requestObject)
                //eslint-disable-next-line
                .then((response) => {
                    resolve();
                })
                .catch(() => {
                    reject();
                });
        });
    },
    //eslint-disable-next-line
    setSelectedCertificateForAuthentication({ commit, state }, id) {
        commit("setSelectedCertificateForAuthentication", id);
    },
};

export const mutations = {
    setSelectedCertificateForAuthentication(state, payload) {
        state.selected_certificate_for_authentication = payload;
    },
    setCertificatesForVetting(state, payload) {
        state.agency_certificates_for_vetting = payload.agency_info;
        state.authentication_stats = payload.stats;
        state.certificates_history = payload.agency_info;

        // certificates for vetting
        state.agency_certificates_for_vetting = state.agency_certificates_for_vetting.map((record) => {
            let obj = {
                agency: record.agency,
                remaining_quota: record.remaining_quota,
                certificates_for_authentication: [],
                certificates_history: record.certificates_history,
            };

            obj.certificates_for_authentication = record.certificates_for_authentication.map((certificate) => {
                if (certificate.authentication_status == "Pending Authentication") {
                    return { value: 3, ...certificate };
                }
                if (certificate.authentication_status == "Not Authenticated") {
                    return { value: 2, ...certificate };
                }
                if (certificate.authentication_status == null) {
                    return { value: 2, ...certificate };
                }
            });

            return obj;
        });
    },
};
